import { cn } from '@/lib/utils';
import { benefitLabels } from '@/data/mockData';

const benefitKeys = Object.keys(benefitLabels);

interface RecipeBenefitFiltersProps {
  selected: string[];
  onToggle: (key: string) => void;
}

const RecipeBenefitFilters = ({ selected, onToggle }: RecipeBenefitFiltersProps) => (
  <div className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-hide">
    {benefitKeys.map((key) => (
      <button
        key={key}
        onClick={() => onToggle(key)}
        className={cn(
          "flex-shrink-0 px-2 py-0.5 rounded-md text-[10px] transition-all border whitespace-nowrap",
          selected.includes(key)
            ? "bg-primary/10 border-primary/30 text-primary font-medium"
            : "bg-card border-border text-muted-foreground"
        )}
      >
        {benefitLabels[key]}
      </button>
    ))}
  </div>
);

export default RecipeBenefitFilters;
